import { useState } from "react"
import { makeQuery } from "../mappers";
import useToast from "./useToast";
import { fetchEventSource } from '@microsoft/fetch-event-source';

export default function useChatGPT() {

    const [data, setData] = useState('');
    const [done, setDone] = useState(false);
    const [start, setStart] = useState(false);

    const headers = {
        
    }

    async function prompt(obj) {
        setData('')
        setDone(false)
        setStart(true)
        const url = `https://lab.teamyab.com/api/gpt/search?${makeQuery(obj)}`;        

        let timer = setTimeout(() => {
            setDone(true);
        }, 5000); 

        await fetchEventSource(url, {
            headers: headers,
            openWhenHidden: true,
            onmessage(event) {
                setStart(false)
                let data2 = JSON.parse(event.data);
                clearTimeout(timer);
                timer = setTimeout(() => {
                    setDone(true);    
                }, 5000); 
                setData(prev => prev + data2) 
            },

            onerror(error) {            
                throw error;
            }
            
        });
    }

    return {
        data,
        done,
        start,
        setData,
        setDone,
        prompt
    }
}
